export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.5.27-0948.40",
  commitId: "eec55affde93de35ba096c0a1d51e6ff73f73a09",
  commitTime: "2026-05-27T09:48:40.000Z",
});
